export interface SanitizeFileNameOptions {
  fallback?: string;
  lowercase?: boolean;
  replacements?: Record<string, string>;
  invalidReplacement?: string;
}

const escapeForRegex = (value: string): string => value.replace(/[-/\\^$*+?.()|[\]{}]/g, '\\$&');
const INVALID_FILE_NAME_CHAR_PATTERN = /[<>:"/\\|?*\u0000-\u001F]/g;

const applyReplacements = (input: string, replacements: Record<string, string>): string => {
  let output: string = input;
  for (const [target, replacement] of Object.entries(replacements)) {
    const escapedTarget: string = escapeForRegex(target);
    const regex: RegExp = new RegExp(escapedTarget, 'g');
    output = output.replace(regex, replacement);
  }
  return output;
};

export const sanitizeFileNameSegment = (
  value: string | undefined | null,
  options: SanitizeFileNameOptions = {}
): string => {
  const fallback: string = options.fallback ?? 'file';
  const lowercase: boolean = options.lowercase ?? true;
  const invalidReplacement: string = options.invalidReplacement ?? '_';
  const replacements: Record<string, string> = options.replacements ?? { ' ': '_', ':': 'x' };

  const baseValue: string = (value ?? '').trim();
  if (baseValue.length === 0) {
    return fallback;
  }

  const normalizedValue: string = lowercase ? baseValue.toLowerCase() : baseValue;
  const replacedValue: string = applyReplacements(normalizedValue, replacements);

  const sanitized: string = replacedValue
    .replace(INVALID_FILE_NAME_CHAR_PATTERN, invalidReplacement)
    .replace(new RegExp(`${escapeForRegex(invalidReplacement)}{2,}`, 'g'), invalidReplacement)
    .replace(new RegExp(`^${escapeForRegex(invalidReplacement)}+|${escapeForRegex(invalidReplacement)}+$`, 'g'), '');

  return sanitized.length > 0 ? sanitized : fallback;
};

